import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { environment } from '@env/environment';
import { MOCK_ROUTES, MockRoute } from '../../mocks/mock-api-registry';

@Injectable()
export class MockApiInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!environment.enableMockApi) {
      return next.handle(req);
    }

    const match = this.findMatch(req);
    if (!match) {
      return next.handle(req);
    }

    console.log(`[MockAPI] ${req.method} ${req.url} → mocked (${match.description})`);

    const body =
      typeof match.response === 'function'
        ? match.response(req.body)
        : match.response;

    const response = new HttpResponse({
      status: match.status,
      body,
      headers: req.headers
    });

    return match.delay
      ? of(response).pipe(delay(match.delay))
      : of(response);
  }

  private findMatch(req: HttpRequest<unknown>): MockRoute | undefined {
    return MOCK_ROUTES.find(route => {
      if (route.method !== req.method) {
        return false;
      }
      if (typeof route.urlPattern === 'string') {
        return req.url.includes(route.urlPattern);
      }
      return route.urlPattern.test(req.url);
    });
  }
}
